import { render, staticRenderFns } from "./NsProductCarousel.vue?vue&type=template&id=a3f55954&"
import script from "./NsProductCarousel.vue?vue&type=script&lang=js&"
export * from "./NsProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsProductCarousel.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports